module.exports = __webpack_public_path__ + "img/ArrDown.13a49aad.svg";